import { CredentialLayout } from "../CredentialLayout";
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { CredentialProps } from "../CredentialProps";
import { Component } from "react";

interface DatabaseViewPageProps extends NSARouterMakerResult, CredentialProps { }

class DatabaseViewPage extends Component<DatabaseViewPageProps>
{
    override render()
    {
        return (
            <CredentialLayout
                {...this.props}
                action={{
                    description: "This section shows the full details of a database credential, including its name, host, and the username and password it stores as secrets. You can review its history and tags and copy any field, while the secret values stay protected."
                }}
                pages={{
                    entity: CredentialEntities.database(this.props),
                    view: {}
                }}
            >
                <></>
            </CredentialLayout>
        );
    }
}

export default DatabaseViewPage;